import { createContext, useContext } from 'react';

/**
 * Shared state behind {@link ShellHost}.
 *
 * Present only while the persistent shell is mounted around the routes.
 * `DashboardLayout` and `Lazy` read it to stand down: the shell and the
 * Suspense boundary already exist one level up, so a page rendering its own
 * would nest a second shell, and a per-route boundary would blank the screen
 * on every navigation instead of holding the current page.
 *
 * Split from the component so that file exports only a component (Fast
 * Refresh), same as page-crumbs-context.ts.
 */
export interface ShellHostState {
  /** A page that owns its own scroll regions (split-pane queues) sets this. */
  setFullHeight: (fullHeight: boolean) => void;
}

export const ShellHostCtx = createContext<ShellHostState | null>(null);

/** True inside the persistent shell. */
export function useInShellHost(): boolean {
  return useContext(ShellHostCtx) !== null;
}
